export { getRecentHistoryList } from '../src/getRecentHistory';
